import React from 'react';
import { Card, CardMedia} from '@mui/material';

function PictureCard({ image, alt }) {
  return (
    <Card sx={{ width: 'auto', mb: 3, display: 'inline-block' }}>
      <CardMedia
        component="img"
        image={image}
        alt={alt}
        sx={{ display: 'block', maxWidth: '100%', height: 'auto', objectFit: 'contain', maxHeight: '50vh'}}
      />
    </Card>
  );
}

export default PictureCard;
